module.exports = __webpack_public_path__ + "img/advanced-created-card.af64fd98.png";